<div class="d-flex my-4" [class.move-right]="isReplyComment" [attr.id]="commentView.source.entity_id">
  <app-small-profile-image
    [profileImage]="commentView.source.creator.image_url"
    [accountStatus]="commentView.source.creator.account_status"
    [dataTestId]="'comment-sender-' + indexLabel"
    [link]="getLink(commentView.source.creator)"
  ></app-small-profile-image>
  <div class="media-body text-truncate w-100 ms-2">
    <div class="d-flex justify-content-between mt-0">
      <app-profile-link
        [dataTestId]="'comment-sender-username-' + indexLabel"
        [cssStyles]="'text-truncate comment-sender comment-title'"
        [status]="getStatus(commentView.source.creator)"
        [userId]="commentView.source.creator.user_id"
        [text]="commentView.source.creator.displayed_name"
      ></app-profile-link>

      <a data-test-id="comment-date" class="comment-date d-none d-sm-block no-hover">
        {{ commentView.source.creation_date | date: DATE_TIME_FORMAT_LONG }}
      </a>
      <button
        *ngIf="commentView.source.permissions.remove"
        type="button"
        aria-label="Remove comment"
        class="d-flex btn btn-link text-dark py-0 px-1 mt-n2 align-items-center"
        [attr.data-test-id]="'comment-remove-btn-' + indexLabel"
        (click)="onRemoveComment()"
      >
        <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
      </button>
    </div>
    <p data-test-id="comment-date-mobile" class="comment-date d-sm-none remove-padding no-hover">
      {{ commentView.source.creation_date | date: DATE_TIME_FORMAT_LONG }}
    </p>
    <div [attr.data-test-id]="'comment-text-' + indexLabel">
      <ng-container *ngIf="!repliedCommentInfo?.replied_comment_ref">
        <app-profile-link
          *ngIf="commentView.repliedUser"
          [dataTestId]="'comment-reply-sender-username-' + indexLabel"
          [cssStyles]="'display_contents display_title replied-user text-truncate'"
          [status]="getStatus(commentView.repliedUser)"
          [userId]="commentView.repliedUser.user_id"
          [text]="commentView.repliedUser.displayed_name"
        ></app-profile-link>

        <span [attr.data-test-id]="'comment-text-' + indexLabel" class="comment-text d-flex">
          {{ commentView.source.text }}
        </span>
      </ng-container>

      <ng-container *ngIf="repliedCommentInfo?.replied_comment_ref as repliedComment"
        ><span class="quoted-text-container mb-0 d-flex align-items-start">
          <app-profile-link
            [dataTestId]="'link-' + repliedComment.creator_id"
            [cssStyles]="'replied-replied-user display_contents text-truncate display_title background-gray pe-1'"
            [status]="repliedComment.creator_status"
            [userId]="repliedComment.creator_id"
            [text]="repliedComment.creator_name"
          ></app-profile-link>

          <ng-container *ngIf="repliedComment.quoted_text as quote">
            <button
              role="button"
              class="scroll-button background-gray"
              [attr.data-test-id]="'button-' + repliedComment.comment_id"
              (click)="scrollToElement(repliedComment.comment_id)"
            >
              {{ quote.length > COMMENT_QUOTE_LENGTH ? (quote | slice: 0 : COMMENT_QUOTE_LENGTH) + '...' : quote }}
            </button>
          </ng-container>
        </span>
        <p class="mb-0 comment-text line-text">{{ repliedCommentInfo.text }}</p>
      </ng-container>
    </div>
    <div
      *ngIf="allowedReply"
      class="reply-btn"
      [attr.data-test-id]="'comment-reply-' + indexLabel"
      (click)="onReplyComment()"
    >
      <h4 class="mb-0">
        {{ 'POSTS_POST_DETAIL_INFO_COMMENT_REPLY_HINT' | translate }}
      </h4>
    </div>
    <ng-container *ngIf="showReply">
      <app-commentary-form-field
        data-test-id="comment-form"
        [userAvatarVisibility]="true"
        [indexLabel]="indexLabel"
        [maxLength]="MAX_LENGTH"
        [counterVisibility]="true"
        [commentPosition]="commentPosition"
        [loadedComments]="loadedComments"
        [placeholderPhrases]="PLACEHOLDER_PHRASES"
        (sendTextMessage)="onSendMessage($event)"
        (hideReply)="onShowReply()"
        (dirtyForm)="setFormStatus($event)"
      ></app-commentary-form-field>
    </ng-container>
  </div>
</div>
